export enum SnomedCategoryType {
    DrugAbuseHistory = 1,
    FallHistory = 2
}

export interface SnomedCategory {
    code: number;
    categoryTypeId: SnomedCategoryType;
    recommendedAssessmentText: Undefinable<string>;
}
